export default "__VITE_ASSET__Dc6Yc9K3__"